interface CIRCLE_TICK_PROPS {
  circleColor?: string;
  tickColor?: string;
}

export const CircleTick = ({
  circleColor = '#00C75A',
  tickColor = '#16CC65',
}: CIRCLE_TICK_PROPS): JSX.Element => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="14.5" fill="white" stroke={circleColor} />
      <path
        d="M10.5 14.136L13.1697 17.34L20.1109 12"
        stroke={tickColor}
        strokeWidth="1.3152"
        strokeLinecap="round"
      />
    </svg>
  );
};
